<template>
<Dialog header="Lütfen Projeleri Seçin" 
v-model:visible="show_modal" 
:breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '50vw'}"
:modal="true"
>


<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>


<template v-if="!loading">
	<hr>
	<br/>
	<div class="field-checkbox" v-for="project in projects">
	    <Checkbox :inputId="'project'+project.id" :name="project.name" :value="project.id" v-model="selectedprojects" :id="'project'+project.id"/>
	    <label :for="'project'+project.id">{{project.name}}</label>
	</div>




</template>


<template #footer>
<Button :label="$store.state.languages.lang_phrases.iptal" icon="pi pi-times" @click="hideModal" class=" p-button-danger p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting"/>
<Button :label="$store.state.languages.lang_phrases.kaydet" icon="pi pi-check" @click="submit"  class=" p-button-primary p-button-outlined  p-button-sm"  :loading="submitting"/>
</template>

</Dialog>
</template>

<script>
export default {

  name: 'SuppliersTableProjectsModal',
  props:["selectedsuppliers"],

  data () {
    return {
    	show_modal:false,
    	loading:true,
    	projects:[],
    	flows:[],
    	selectedprojects:[],
    	selectdflows:[],
    	submitting:false,
    }
  },
  methods:{
  	showModal(action)
  	{
  		this.show_modal = true
  		this.getBrandProjects()
  	},
  	hideModal()
  	{
  		this.$emit("closemodal")
  		this.show_modal = false
  		this.submitting = false
  		this.selectedprojects = []
  	},
  	async getBrandProjects()
  	{
  		this.loading = await true
  		let first = await this.selectedsuppliers[0]
  		this.projects = await this.generalApiGetWithoutLoader("brand_projects/"+first.brand_id)
  		this.loading = await false
  	},
  	async getProjectFlows()
  	{
  		this.loading = await true
  		let first = await this.selectedsuppliers[0]
  		this.projects = await this.generalApiGetWithoutLoader("brand_projects/"+first.brand_id)
  		this.loading = await false
  	},
  	submit()
  	{
  		this.submitting = true
  		let formdata = new FormData()
  		formdata.append("selectedprojects",JSON.stringify(this.selectedprojects))
  		formdata.append("selectedsuppliers",JSON.stringify(this.selectedsuppliers))
  		console.log(this.selectedprojects)
  		console.log(this.selectedsuppliers)
  		this.generalSubmission(formdata,"suppliers/add_to_project",this.afterSubmit)
  	},
  	afterSubmit(response)
  	{
  		console.log(response.data)
  		this.submitting = false
  		this.selectedprojects = []
  		this.hideModal()
  	},
  }
}
</script>

<style lang="css" scoped>
</style>